export const encodeYamlDataType = (decodedYaml: string) =>
  window.btoa(decodedYaml);
